import React, {
  useMemo,
} from 'react'

import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Locale from './locale'


export default function PurposesParagraph({ purposes = [], specialFeatures = []}) {
  const values = useMemo(() => {
    const list = [...purposes, ...specialFeatures]
      .map(({ name }) => name)
      .sort()
      .join(', ')

    return {
      b: (chunks) => (<b>{ chunks }</b>),
      list,
    }
  }, [purposes, specialFeatures])

  return (
    <FormattedMessage
      { ...Locale.purposesAndSpecialFeatures }
      values={ values }
    />
  )
}

PurposesParagraph.propTypes = {
  purposes: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
  specialFeatures: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ),
}
